import type {
  PresetColorType,
  PresetStatusColorType,
} from 'antd/es/_util/colors';
import type { LiteralUnion } from 'type-fest';

export enum VCC_STATUS {
  INACTIVE = 'INACTIVE',
  CANCELED = 'CANCELED',
  TO_CHARGE = 'TO_CHARGE',
  CHARGED = 'CHARGED',
  TO_REFUND = 'TO_REFUND',
  DEACTIVATED = 'DEACTIVATED',
}

export type VccStatusDisplayInfo = {
  text: string;
  color: LiteralUnion<PresetColorType | PresetStatusColorType, string>;
  status: VCC_STATUS;
  history: string[];
};
